import {
  AssignLoadToLaneRequest,
  LoadLaneModel,
  UnassignLoadFromLaneRequest,
  UpdateLoadLaneMovementRequest,
} from '@/types';
import {
  Core,
  Load_Lanes,
  LOAD_LANES_ASSIGN,
  LOAD_LANES_MOVEMENT,
  LOAD_LANES_UNASSIGN,
} from '../Core';

class LoadLanes extends Core {
  getLoadLanes = async (siteId: number, customerId: number) =>
    this.get<LoadLaneModel>(Load_Lanes(siteId, customerId));

  assignLoadToLane = async (data: AssignLoadToLaneRequest) =>
    this.put<boolean>(LOAD_LANES_ASSIGN(), data);

  unassignLoadFromLane = async (data: UnassignLoadFromLaneRequest) =>
    this.put<boolean>(LOAD_LANES_UNASSIGN(), data);

  updateLoadLaneMovement = async (data: UpdateLoadLaneMovementRequest) =>
    this.put<boolean>(LOAD_LANES_MOVEMENT(), data);
}

export const loadlanes = new LoadLanes();
